import { types } from 'mobx-state-tree';
import {
  TBusinessFormData,
  TCategoryFormData,
  TChangePasswordFormData,
  TEmployeeFormData,
  TEventFormData,
  TGroupFormData,
  THistoryFormData,
  TMainVisualFormData,
  TMaterialsFormData,
  TNewsFormData,
  TNoticeFormData,
  TPartnerFormData,
  TPopupFormData,
  TRecruitFormData,
} from 'src/@types';

export const INIT_POPUP_FORM_DATA: TPopupFormData = {
  title: '',
  desc: '',
  startDt: 0,
  endDt: 0,
  width: 0,
  height: 0,
  environment: '',
  displayHours: 0,
  topPosition: 0,
  leftPosition: 0,
};

// 직원 관리 폼 초기 데이터
export const INIT_EMPLOYEE_FORM_DATA: TEmployeeFormData = {
  oprtrSid: 0,
  loginId: '',
  oprtrNm: '',
  oprtrGroupSid: 0,
  oprtrGroupSidList: [], // 그룹 ID 정보
  oprtrGroupList: [], // 그룹 정보
  oprtrSttsCd: 10602, // 계정상태: 정상(10601), 비활성(10602), 잠금(10603)
  beforePwd: '',
  pwd: '',
  pwdCorrect: '',
  regDt: 0,
  updDt: 0,
};

// 공지사항 관리 폼 초기 데이터
export const INIT_NOTICE_FORM_DATA: TNoticeFormData = {
  noticeSid: 0,
  prNotiCtgyCd: '',
  title: '',
  descript: '',
  filePath: [],
  deleteFilesPath: [],
  regDt: 0,
  updDt: 0,
};

// 뉴스 관리 폼 초기 데이터
export const INIT_NEWS_FORM_DATA: TNewsFormData = {
  newsSid: 0,
  prNewsCtgyCd: '',
  source: '',
  title: '',
  link: '',
  descript: '',
  filePath: [],
  deleteFilesPath: [],
  regDt: 0,
  updDt: 0,
  originRegDt: 0,
};
// 채용 지원 관리 폼 초기 데이터
export const INIT_RECRUIT_FORM_DATA: TRecruitFormData = {
  recruitSid: 0,
  expCd: 0,
  applyFieldCd: 0,
  veteranCd: 0,
  disabledCd: 0,
  nameKr: '',
  nameEn: '',
  desiredSalary: 0,
  genderTypeCd: 0,
  email: '',
  phone: '',
  emergencyContact: '',
  birthDate: '',
  calendarTypeCd: 0,
  applySrc: '',
  address: '',
  resumeFilePath: [],
  applyDt: 0,
  // recruitStatusCd: null,
  recruitStatusCd: '',
  memo: '',
};

export const INIT_MAIN_VISUAL_FORM_DATA: TMainVisualFormData = {
  mode: 'data',
  visualSid: 0,
  mainText: { text: '', color: '#000' },
  subText: { text: '', color: '#000' },
  bgPath: [],
  // dataContent: {
  //   mainText: { text: '', color: '#000' },
  //   subText: { text: '', color: '#000' },
  //   bgPath: null,
  // },
  editorContent: {
    desktop: {
      shapes: types.array(types.frozen()).create(),
      assets: types.array(types.frozen()).create(),
    },
    tablet: {
      shapes: types.array(types.frozen()).create(),
      assets: types.array(types.frozen()).create(),
    },
    mobile: {
      shapes: types.array(types.frozen()).create(),
      assets: types.array(types.frozen()).create(),
    },
  },
  useYn: false,
  ordr: 0,
  deleteFilesPath: [],
  lang: '',
};
export const INIT_HISTORY_FORM_DATA: THistoryFormData = {
  historyDate: 0,
  titleKo: '',
  titleEn: '',
  desc: '',
};
export const INIT_PARTNER_FORM_DATA: TPartnerFormData = {
  logoImgPath: '',
  categoryType: 0,
  partnerName: '',
  partnerSid: 0,
  useYn: true,
};
export const INIT_EVENT_FORM_DATA: TEventFormData = {
  eventTypeCd: '',
  startDt: 0,
  location: '',
  title: '',
  desc: '',
};
export const INIT_MATERIAL_FORM_DATA: TMaterialsFormData = {
  materialSid: 0,
  title: '',
  file: '',
  type: 0,
  useYn: true,
};
export const INIT_CATEGORY_FORM_DATA: TCategoryFormData = {
  useYn: true,
  pCategory: 0,
  categoryNm: '',
  mainTitle: '',
  subTitle: '',
  mainDesc: '',
  subDesc: '',
  pipeline: '',
  pipelineList: '',
};
export const INIT_BUSINESS_FORM_DATA: TBusinessFormData = {
  bnCatCd: 0,
  bnSubCatCd: '',
  pipelineCd: '',
  useYn: true,
  lang: '',
  ordr: 0,
  title: '',
  summary: '',
  thumbPath: '',
  detailPath: [],
  descript: '',
  subContentInfos: [],
};

export const INIT_GROUP_FORM_DATA: TGroupFormData = {
  oprtrGroupNm: '',
  dscrpt: '',
  roleIdList: ['ADMIN'],
  useYn: true,
};

export const INIT_CHANGE_PASSWORD_DATA: TChangePasswordFormData = {
  currentPwd: '',
  pwd: '',
  pwdCorrect: '',
};
